
export function getAgeValidationText(errorMessage = "") {
  const errorMarkup = errorMessage
    ? `<div class="age-modal-error">${errorMessage}</div>`
    : "";

  return `<div class="age-modal-text">
    <div class="age-modal-icon" aria-hidden="true">🍷</div>
    <div class="age-modal-subtitle">You must be 21 years or older to browse this website.</div>
    <div class="age-modal-disclaimer">Please drink responsibly.</div>
    ${errorMarkup}
  </div>`;
}

export function getAgeValidationParams(confirmCB, cancelCB, errorMessage = "") {
  return {
    customClass: "age-validation-modal",
    title: "Age Verification Required",
    confirmButtonText: "I'm 21 or Older - Enter Site",
    cancelButtonText: "I'm Under 21 - Exit",
    showCancelButton: true,
    showConfirmButton: true,
    html: true,
    onConfirm: confirmCB,
    onCancel: cancelCB,
    confirmButtonColor: "#51B8E0",
    text: getAgeValidationText(errorMessage)
  };
}



// WEBPACK FOOTER //
// ./src/utils/swalHelpers.js